import { userRequest } from '../lib/userRequest'

// move into user lib
export const getCurrentUser = () => {
  return userRequest('post', '/whoami', {})
}

export const logout = () => {
  return userRequest('post', '/logout', {})
}

export const extend = (destination = null, forceRefresh = false) => {
  const params = {
    destination,
    force: forceRefresh ? 1 : 0
  }
  return userRequest('post', '/extend', params)
}
